export function hexToRgb(hex) {
  hex = hex.replace(/^#/, '');

  if (!/^([0-9a-fA-F]{3}){1,2}([0-9a-fA-F]{2})?$/.test(hex)) {
    return null;
  }

  if (hex.length === 3) {
    hex = hex.replace(/([0-9a-fA-F])/g, '$1$1');
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const a = hex.length === 8 ? parseInt(hex.substring(6, 8), 16) / 255 : 1;

  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export const destructureRgbColor = rgbColorString => {
  if (typeof rgbColorString === 'string') {
    let rgbValue = null as string | null;
    if (rgbColorString.startsWith('rgba(')) {
      rgbValue = rgbColorString;
    } else if (rgbColorString.startsWith('rgb(')) {
      // Convert rgb() to rgba() with alpha = 1
      rgbValue = rgbColorString.replace('rgb(', 'rgba(').replace(')', ', 1)');
    } else if (rgbColorString.startsWith('#')) {
      rgbValue = hexToRgb(rgbColorString);
    } else if (rgbColorString === 'transparent') {
      rgbValue = `rgba(0, 0, 0, 0)`;
    }

    if (rgbValue) {
      const values = rgbValue.split(/(?:rgba\()|(?:,)|(?:\))/).filter(Boolean);
      const destructuredRgb = {
        red: parseInt(values[0]),
        green: parseInt(values[1]),
        blue: parseInt(values[2]),
        alpha: parseFloat(values[3]) || 1,
        style: rgbValue
      };

      return destructuredRgb;
    }
  }
};

export function rgbaToHex(rgba: string, withAlpha: boolean = false): string {
  const match = rgba.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d*(?:\.\d+)?(?:\.\d+)?)\)$/);
  if (!match) {
    throw new Error('Invalid RGBA color value.');
  }

  const r = parseInt(match[1], 10);
  const g = parseInt(match[2], 10);
  const b = parseInt(match[3], 10);
  const a = Math.round(parseFloat(match[4]) * 255);

  const hexR = r.toString(16).padStart(2, '0');
  const hexG = g.toString(16).padStart(2, '0');
  const hexB = b.toString(16).padStart(2, '0');
  const hexA = a.toString(16).padStart(2, '0');

  if (withAlpha) {
    return `#${hexR}${hexG}${hexB}${hexA}`;
  }

  return `#${hexR}${hexG}${hexB}`;
}

export function convertRGBToRGBA(rgbStr) {
  const rgbPattern = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/;
  const match = rgbStr.match(rgbPattern);

  if (match) {
    const red = parseInt(match[1], 10);
    const green = parseInt(match[2], 10);
    const blue = parseInt(match[3], 10);
    return `rgba(${red}, ${green}, ${blue}, 1)`;
  }
  return rgbStr;
}

export function isRGBFormat(str) {
  const rgbPattern = /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/;
  return rgbPattern.test(str);
}
